import { readApiJson } from "./apiResponse";

const API_BASE = String(process.env.REACT_APP_API_BASE || "").replace(/\/$/, "");

async function requestContent(path = "", body, signal) {
  const token = ["token", "authToken", "jwt", "accessToken", "access_token"]
    .map((key) => localStorage.getItem(key) || sessionStorage.getItem(key)).find(Boolean);
  const response = await fetch(`${API_BASE}/api/content${path}`, {
    method: body === undefined ? "GET" : "POST",
    credentials: "include",
    signal,
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(body === undefined ? {} : { "Content-Type": "application/json" }),
    },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  return readApiJson(response, "Content");
}

export async function fetchContentLibrary(signal) {
  const payload = await requestContent("", undefined, signal);
  if (!Array.isArray(payload.rows)) throw new Error("Invalid content response.");
  return payload.rows;
}

export function mutateContentLibrary(contentType, ids, action, changes) {
  return requestContent("/bulk", { content_type: contentType, ids, action, changes });
}

export function contentMutationForAction(action, metadata = {}) {
  switch (action) {
    case "assign_owner": return { action: "update", changes: { owner_name: metadata.ownerName } };
    case "change_status": return { action: "update", changes: { status: metadata.nextStatus } };
    case "publish_content": return { action: "update", changes: { status: metadata.publishStatus } };
    case "archive_content": return { action: "update", changes: { status: "Archived" } };
    case "duplicate_content": return { action: "duplicate" };
    case "delete_content": return { action: "delete" };
    default: return null;
  }
}
